<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";
import MaskedInput from "vue-text-mask";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.component("v-select", vSelect);

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Detalle producto component
 */
export default {
  page: {
    title: "Información del Producto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    "masked-input": MaskedInput,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      apiUrl: process.env.VUE_APP_URL,
      total: 0,
      arrayUbicaciones: [],
      arrayDetalle: [],
      arrayTiendas: [],
      arrayEstante: [],
      ubicacion_stock: "",
      cantidad: "",
      /*   pasillo:"",
      seccion:"", */
      arrayDepa: [],
      variosmodelos: [],
      modelos: [],
      fields: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "codigo_stock",
          sortField: "codigo_stock",
          title: "Codigo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "existencia_stock",
          sortField: "existencia_stock",
          title: "Existencia",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "notificacion_stock_min",
          sortField: "notificacion_stock_min",
          title: "Stock Minimo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "precio_compra",
          sortField: "precio_compra",
          title: "Precio Compra",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "precio_venta",
          sortField: "precio_venta",
          title: "Precio Venta",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "marca.nombre_marca",
          sortField: "marca.nombre_marca",
          title: "Marca",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "presentacione.nombre_presentacion",
          sortField: "presentacione.nombre_presentacion",
          title: "Presentación",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "modelo",
          sortField: "modelo",
          title: "Modelo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "5%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "5%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      formPro: {
        existencia_g: "",
        departamento: "",
        tiendaid: "",
        code: "",
        stock_min: "",
        stock_max: "",
        modelo: "",
        autoid: "",
        marca: "",
        presentacion: "",
        subpresentacion: "",
        precio_compra: "",
        precio_venta: "",
        precio_taller: "",
        precio_mayore: "",
        precio_frecuente: "",
        estante: "",
        state: true,
        id: 0,
      },
      formget: {
        nombre: "",
        categoria: "",
        state: true,
      },
      formSub: {
        nombre: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información del Producto",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],

      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  validations: {
    formSub: {
      nombre: { required },
    },
    formPro: {
      tiendaid: { required },
      departamento: { required },
      estante: { required },
    },
    arrayDetalle: { required },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detallProducto();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    validacion() {
      this.$v.$touch();
      if (this.arrayDetalle.length > 0) {
        this.showmodalL = true;
        this.asignarExistencias();
      }
    },
    eliminarDetalle(index) {
      let me = this;
      me.arrayDetalle.splice(index, 1);
    },
    encuentra(id) {
      let sw = 0;
      for (let i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].idubicacion == id) {
          sw = true;
        }
      }
      return sw;
    },
    agregar() {
      this.$v.$touch();
      const me = this;
      if (
        this.cantidad != "" &&
        this.formPro.departamento !=
          "" /* && this.pasillo != "" && this.seccion != "" */
      ) {
        if (me.encuentra(this.formPro.departamento.id)) {
          Vue.toasted.error(
            this.formPro.departamento.nombre_departamento +
              " ya existen en el detalle",
            this.options
          );
        } else {
          this.arrayDetalle.push({
            tienda: this.formPro.tiendaid.nombre_tienda,
            ubicacion: this.formPro.departamento.nombre_departamento,
            idstock: this.formPro.id,
            idubicacion: this.formPro.departamento.id,
            cantidad: parseFloat(this.cantidad),
            /* estanteId:this.formPro.estante.id,
                pasillo:this.pasillo,
                seccion:this.seccion */
          });
          this.cantidad = "";
          /* this.pasillo = ""; 
            this.seccion = "";  */
        }
      }
    },
    cerrarModalUbicacion() {
      this.arrayTiendas = [];
      this.arrayDepa = [];
      this.arrayEstante = [];
      this.cantidad = "";
      this.ubicacion_stock = "";
      this.$refs["modal-edit-existencia"].hide();
    },
    async modelos_s(id) {
      const response = await axios.get(
        process.env.VUE_APP_URL + "productos/stock/ver_modelos?id=" + id,
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.variosmodelos = response.data.data;
      this.showModalE = true;
      // console.log(this.variosmodelos)
      return 0;
    },
    async infoStock() {
      const me = this;
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL +
            "productos/stock/ubicaciones?id=" +
            this.formPro.id,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        me.arrayUbicaciones = response.data.ubicacion;
        // console.log(me.arrayUbicaciones)
      } catch (error) {
        console.log(error);
      }
    },
    //BUSQUEDAS
    async selectOpc(action) {
      if (action == 1) {
        this.arrayTiendas = [];
        try {
          const response = await axios.get(
            process.env.VUE_APP_URL + "tiendas/select",
            {
              headers: { "x-token": this.userT.token },
            }
          );
          this.arrayTiendas = response.data;
          this.formPro.tiendaid = this.arrayTiendas[0];
          this.selectOpc(2);
          // console.log(this.arrayTiendas)
        } catch (error) {
          console.log(error);
        }
      }
      if (action == 2) {
        let me = this;
        this.arrayDepa = [];
        try {
          const response = await axios.get(
            process.env.VUE_APP_URL +
              "departamentos/busqueda?id=" +
              this.formPro.tiendaid.id +
              "&stock=" +
              this.formPro.id,
            {
              headers: { "x-token": this.userT.token },
            }
          );
          me.arrayDepa = response.data.ubicacion;
        } catch (error) {
          console.log(error);
        }
      }
      if (action == 3) {
        let me = this;
        this.arrayEstante = [];
        this.formPro.estante = "";
        try {
          const response = await axios.get(
            process.env.VUE_APP_URL +
              "departamentos/estante/busqueda?departamento=" +
              this.formPro.departamento.id,
            {
              headers: { "x-token": this.userT.token },
            }
          );
          me.arrayEstante = response.data.data;
        } catch (error) {
          console.log(error);
        }
      }
    },

    setData(data, opc) {
      if (opc === "stock") {
        this.formPro.code = data.codigo_stock;
        this.formPro.existencia_g = data.existencia_stock;
        this.formPro.id = data.id;
        this.selectOpc(1);
      }
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    //Detalle Presentacion
    detallProducto() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/viewProducto?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.modelos = response.data.data[0].stocks;
          this.formget.nombre = response.data.data[0].nombre_producto;
          this.formget.categoria =
            response.data.data[0].categoria.nombre_categoria;
          this.formget.state = response.data.data[0].estado_producto;
          //  console.log(response.data)
        });
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },
    //Desactivar registro
    desactivate() {
      const { id, nombre } = this.formSub;
      axios
        .put(
          process.env.VUE_APP_URL + "productos/stock/desactivate",
          {
            id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(nombre + " Desactivado", this.options);
          this.detallProducto();
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    //Asignar Asistencias
    asignarExistencias() {
      const me = this;
      const { id } = me.formPro;
      axios
        .put(
          process.env.VUE_APP_URL + "productos/stock/update_existencia",
          {
            detalles: me.arrayDetalle,
            id,
            existencia: this.total,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalN = false;
          Vue.toasted.success("Existencia Actualizada", this.options);
          me.detallProducto();
          me.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.error = false;
          this.errorMessage = error.message;
          console.error("Error!", error);
          this.showmodalL = false;
        })
        .finally(() => {
          this.showModalN = false;
          this.showmodalL = false;
        });
    },
    //Activar registro
    activate() {
      const { id, nombre } = this.formSub;
      axios
        .put(
          process.env.VUE_APP_URL + "productos/stock/activate",
          {
            id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(nombre + " Activado", this.options);
          this.detallProducto();
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },

    //ACtualizar registro
    update() {
      const { nombre, id } = this.formSub;
      const me = this;
      axios
        .put(
          process.env.VUE_APP_URL + "autos/modelo/update",
          {
            nombre: nombre,
            id: id,
            auto: parseInt(this.$route.params.id),
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success(nombre + " Actualizado", this.options);
          me.detallProducto();
          me.$refs.vuetable.refresh();
          this.showModalE = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },

    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        /*   case "save": {
       this.$v.$reset();
      this.limpiarVariables();
         
      // console.log("entrando a resetear")
          break;
        } */
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formSub.id = 0;
      this.formSub.nombre = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "existencia": {
          this.arrayDetalle = [];
          this.formPro.tiendaid = "";
          this.formPro.departamento = "";
          this.formPro.estante = "";
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "history-item") {
        const idhistorial = data.id;

        this.$router.push({
          name: "historial_precios",
          params: { id: idhistorial, idpro: this.$route.params.id },
          shallow: true,
        });
      }
      if (action == "edit-item") {
        let idsto = data.id;
        this.$router.push({
          name: "stockproducto",
          params: { id: this.$route.params.id, opc: "update", idstock: idsto },
          shallow: true,
        });
      }
      if (action == "new-item") {
        this.formSub.id = 0;
        this.formSub.nombre = "";
      }
      if (action == "desactivate-item") {
        this.formSub.nombre = data.codigo_stock;
        this.formSub.id = data.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.formSub.nombre = data.codigo_stock;
        this.formSub.id = data.id;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      let resultado = 0.0;
      for (let i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].cantidad == "") {
          resultado = resultado + 0;
        } else {
          resultado = resultado + parseInt(this.arrayDetalle[i].cantidad);
        }
      }
      return resultado.toFixed(2);
    },
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Activar {{ this.formSub.nombre }}?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Desactivar {{ this.formSub.nombre }}?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- MODAL PARA ACTUALIZAR LAS EXISTENCIAS -->
        <b-modal
          centered
          no-close-on-backdrop
          ref="modal-edit-existencia"
          id="modal-edit-existencia"
          v-model="showModalN"
          @hidden="closeModal('existencia')"
          scrollable
          title="Actualizar existencia"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <b-form>
            <b-tabs no-fade pills>
              <br />
              <b-tab title="Existencias" title-item-class="w-30 text-center">
                <b-row>
                  <div class="col-12">
                    <div class="mb-3">
                      <div class="form-group">
                        <label class="form-control-label"
                          ><b>Producto</b></label
                        >
                        <h3><p v-text="formPro.code"></p></h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <div class="form-group">
                        <label class="form-control-label"
                          ><b>Existencia Total</b></label
                        >
                        <h3><p v-text="formPro.existencia_g"></p></h3>
                      </div>
                    </div>
                  </div>
                </b-row>
                <b-form-group>
                  <b-table-simple responsive>
                    <b-tbody>
                      <tr>
                        <th>Nombre Tienda</th>
                        <th>Nombre Departamento</th>
                        <th>Existencia</th>
                      </tr>
                    </b-tbody>

                    <tbody v-if="arrayUbicaciones.length">
                      <tr
                        v-for="(item, index) in arrayUbicaciones"
                        :key="index"
                      >
                        <td v-text="item.tienda.nombre_tienda"></td>
                        <td v-text="item.nombre_departamento"></td>
                        <td
                          v-text="
                            item.detalle_departamentos[0]
                              .existencia_departamento
                          "
                        ></td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr style="background-color: #ceecf5">
                        <td colspan="6">No hay registros para mostrar.</td>
                      </tr>
                    </tbody>
                  </b-table-simple>
                </b-form-group>
              </b-tab>
              <b-tab
                title="Asignar Existencias"
                title-item-class="w-40 text-center"
              >
                <b-row>
                  <div class="col-12">
                    <div class="mb-3">
                      <div class="form-group">
                        <label class="form-control-label"
                          ><b>Ubicacion: </b></label
                        >
                        <h2><p v-text="formPro.tienda"></p></h2>
                      </div>
                    </div>
                  </div>
                </b-row>
                <b-row>
                  <div class="col-12">
                    <div class="mb-3">
                      <label>Tienda</label>
                      <v-select
                        disabled
                        v-model.trim="$v.formPro.tiendaid.$model"
                        :state="!$v.formPro.tiendaid.$error"
                        :options="arrayTiendas"
                        label="nombre_tienda"
                      ></v-select>
                      <div
                        :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.formPro.tiendaid.$error &&
                            !$v.formPro.tiendaid.required,
                        }"
                      >
                        Debe seleccionar una tienda
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <label>Departamento</label>
                      <v-select
                        v-model.trim="$v.formPro.departamento.$model"
                        :state="!$v.formPro.departamento.$error"
                        :options="arrayDepa"
                        label="nombre_departamento"
                      ></v-select>
                      <div
                        :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.formPro.departamento.$error &&
                            !$v.formPro.departamento.required,
                        }"
                      >
                        Debe seleccionar una Departamento
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="mb-3">
                      <label for="name">Detalles</label>
                      <b-input-group class="mt-3">
                        <masked-input
                          id="nombre"
                          :mask="[
                          [/[1-9]/, /\d/]
                      ]"
                          v-model="cantidad"
                          type="text"
                          class="form-control"
                          placeholder="Ingrese una Cantidad"
                        ></masked-input>

                        <b-input-group-append>
                          <b-button variant="info" @click="agregar"
                            >Agregar</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </div>
                </b-row>

                <b-table-simple responsive>
                  <b-thead>
                    <tr>
                      <th>Acciones</th>

                      <th>Tienda</th>
                      <th>Departamento</th>
                      <th>Cantidad</th>
                    </tr>
                  </b-thead>

                  <b-tbody>
                    <b-tr v-for="(item, index) in arrayDetalle" :key="index">
                      <b-th>
                        <b-button
                          tabindex="0"
                          v-b-tooltip.focus
                          title="Eliminar"
                          class="icon-content col-xl-4 col-lg-8 col-sm-"
                          size="sm"
                          variant="outline-danger"
                          @click="eliminarDetalle(index)"
                        >
                          <i class="bx bx-trash-alt" />
                        </b-button>
                      </b-th>
                      <b-td v-text="item.tienda"></b-td>
                      <b-td v-text="item.ubicacion"></b-td>
                      <b-td v-text="item.cantidad"></b-td>
                    </b-tr>
                    <b-tr style="background-color: #ceecf5">
                      <b-td colspan="3" align="right"
                        ><strong>Existencias actuales:</strong></b-td
                      >
                      <b-td style="text-align: center; font-weight: bold">
                        {{ formPro.existencia_g }}</b-td
                      >
                    </b-tr>
                    <b-tr style="background-color: #ceecf5">
                      <b-td colspan="3" align="right"
                        ><strong>Existencias nuevas:</strong></b-td
                      >
                      <b-td style="text-align: center; font-weight: bold"
                        >{{ calcularTotal }}
                      </b-td>
                    </b-tr>
                    <b-tr style="background-color: #ceecf5">
                      <b-td colspan="3" align="right"
                        ><strong>Total existencias:</strong></b-td
                      >
                      <b-td style="text-align: center; font-weight: bold"
                        >{{
                          (total =
                            parseFloat(calcularTotal) +
                            parseFloat(formPro.existencia_g))
                        }}
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.arrayDetalle.$error && !$v.arrayDetalle.required,
                  }"
                >
                  Debe Agregar un Detalle
                </div>
              </b-tab>
            </b-tabs>
            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="cerrarModalUbicacion"
                >Cerrar</b-button
              >
              <b-button @click="validacion()" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </b-form>
        </b-modal>

        <!-- Modal para Editar-->
        <b-modal
          centered
          ref="modalView"
          id="modalView"
          title="Modelos"
          no-close-on-backdrop
          v-model="showModalE"
          @hidden="closeModal('view')"
          @show="openModal('view')"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <b-table-simple responsive>
                  <b-tbody>
                    <tr>
                      <th>Modelo</th>
                      <th>Estado</th>
                    </tr>
                  </b-tbody>

                  <tbody v-if="variosmodelos.length">
                    <tr v-for="(item, index) in variosmodelos" :key="index">
                      <td>
                        {{ item.modelo.auto.nombre_auto }}
                        {{ item.modelo.nombre_modelo }}
                      </td>
                      <td>
                        <h5 v-if="item.estado_detalle == true">
                          <span class="badge bg-success ms-1"
                            ><strong>ACTIVO</strong></span
                          >
                        </h5>
                        <h5 v-else>
                          <span class="badge bg-danger ms-1"
                            ><strong>INACTIVO</strong></span
                          >
                        </h5>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr style="background-color: #ceecf5">
                      <td colspan="6">No hay registros para mostrar.</td>
                    </tr>
                  </tbody>
                </b-table-simple>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalE = false"
                >Cerrar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-8">
                  <div class="text-center">
                    <div class="mb-4">
                      <a href="#" class="badge bg-light font-size-12">
                        <i
                          class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                        ></i>
                        Información
                      </a>
                    </div>
                    <h4>Información del Producto</h4>
                  </div>
                  <hr />
                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-3">
                        <div>
                          <p class="text-muted mb-2">Nombre</p>
                          <h5 class="font-size-15">{{ formget.nombre }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div>
                          <p class="text-muted mb-2">Categoría</p>
                          <h5 class="font-size-15">{{ formget.categoria }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Estado</p>
                          <h5 v-if="formget.state == true">
                            <span class="badge bg-success ms-1"
                              ><strong>ACTIVO</strong></span
                            >
                          </h5>
                          <h5 v-else>
                            <span class="badge bg-danger ms-1"
                              ><strong>INACTIVO</strong></span
                            >
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div>
                          <router-link
                            :to="{
                              name: 'productos',
                            }"
                          >
                            <b-button
                              variant="outline-primary"
                              type="button"
                              class="btn btn-rounded mb-2 me-2"
                            >
                              <i class="mdi mdi-arrow-collapse-left"></i>
                              Regresar
                            </b-button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de presentaciones</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <router-link
                      :to="{
                        name: 'stockproducto',
                        params: {
                          id: this.$route.params.id,
                          opc: 'save',
                          idstock: 0,
                        },
                      }"
                    >
                      <button
                        v-b-modal.modal
                        type="button"
                        class="btn btn-success btn-rounded mb-2 me-2"
                        @click="onActionClicked('new-item')"
                      >
                        <i class="mdi mdi-plus me-1"></i> Nueva
                      </button>
                    </router-link>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <div class="d-none d-lg-block">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="modelos"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      v-if="props.rowData.estado_stock"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Editar"
                      variant="outline-primary"
                      @click="onActionClicked('edit-item', props.rowData)"
                      ><i class="bx bx-edit-alt"></i>
                    </b-button>
                    <b-button
                      v-if="props.rowData.estado_stock"
                      @click="setData(props.rowData, 'stock'), infoStock()"
                      v-b-modal.modal-edit-existencia
                      variant="outline-info"
                      ><i :class="'bx bx-plus-medical'"
                    /></b-button>
                    <b-button
                      v-if="props.rowData.estado_stock"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Historial Precios"
                      variant="outline-primary"
                      @click="onActionClicked('history-item', props.rowData)"
                      ><i class="fas fa-history"></i>
                    </b-button>
                    <router-link
                      :to="{
                        name: 'viewstock',
                        params: { id: props.rowData.id },
                      }"
                    >
                      <b-button
                        tabindex="0"
                        v-b-tooltip.focus
                        title="Ver Mas"
                        variant="outline-secondary"
                      >
                        <i :class="'bx bxs-show'" />
                      </b-button>
                    </router-link>
                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Cambiar Estado"
                      :variant="
                        props.rowData.estado_stock == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                      @click="
                        props.rowData.estado_stock == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                        :class="
                          props.rowData.estado_stock == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_stock == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>

                <div slot="precio_compra" slot-scope="props">
                  {{ money(props.rowData.precio_compra_stock) }}
                </div>
                <div slot="precio_venta" slot-scope="props">
                  {{ money(props.rowData.precio_venta_stock) }}
                </div>
                <div slot="presentacion" slot-scope="props">
                  {{
                    props.rowData.sub_presentacione.presentacione
                      .nombre_presentacion
                  }}
                  {{ props.rowData.sub_presentacione.nombre_subpresentacion }}
                </div>
                <div slot="modelo" slot-scope="props">
                  <b-button
                    tabindex="0"
                    v-b-tooltip.focus
                    title="Ver Modelos"
                    variant="outline-secondary"
                    @click="modelos_s(props.rowData.id)"
                  >
                    <i :class="'bx bxs-show'" />
                  </b-button>
                </div>
              </vuetable>
              </div>
              <ResponsiveCards :items="modelos">
                <template #card="{ item }">
                  <div class="rwd-card__head">
                    <span v-if="item.estado_stock" class="badge bg-success">ACTIVO</span>
                    <span v-else class="badge bg-danger">INACTIVO</span>
                    <span class="rwd-card__value">{{ money(item.precio_venta_stock) }}</span>
                  </div>
                  <div class="rwd-card__title">{{ item.codigo_stock }}</div>
                  <div class="rwd-card__sub">
                    {{ item.sub_presentacione && item.sub_presentacione.presentacione ? item.sub_presentacione.presentacione.nombre_presentacion : '' }}
                    {{ item.sub_presentacione ? item.sub_presentacione.nombre_subpresentacion : '' }}
                  </div>
                  <div class="rwd-card__kv"><span>Existencia</span><span>{{ item.existencia_stock }}</span></div>
                  <div class="rwd-card__kv"><span>Stock mínimo</span><span>{{ item.notificacion_stock_min }}</span></div>
                  <div class="rwd-card__kv"><span>Precio compra</span><span>{{ money(item.precio_compra_stock) }}</span></div>
                  <div class="rwd-card__kv"><span>Precio venta</span><span>{{ money(item.precio_venta_stock) }}</span></div>
                  <div class="rwd-card__kv"><span>Marca</span><span>{{ item.marca ? item.marca.nombre_marca : '' }}</span></div>
                  <div class="rwd-card__actions">
                    <b-button-group>
                      <b-button
                        v-if="item.estado_stock"
                        variant="outline-primary"
                        @click="onActionClicked('edit-item', item)"
                        ><i class="bx bx-edit-alt"></i>
                      </b-button>
                      <b-button
                        v-if="item.estado_stock"
                        @click="setData(item, 'stock'), infoStock()"
                        v-b-modal.modal-edit-existencia
                        variant="outline-info"
                        ><i :class="'bx bx-plus-medical'"
                      /></b-button>
                      <b-button
                        v-if="item.estado_stock"
                        variant="outline-primary"
                        @click="onActionClicked('history-item', item)"
                        ><i class="fas fa-history"></i>
                      </b-button>
                      <router-link :to="{ name: 'viewstock', params: { id: item.id } }">
                        <b-button variant="outline-secondary">
                          <i :class="'bx bxs-show'" />
                        </b-button>
                      </router-link>
                      <b-button
                        :variant="item.estado_stock == true ? 'outline-danger' : 'outline-success'"
                        @click="item.estado_stock == true ? onActionClicked('desactivate-item', item) : onActionClicked('activate-item', item)"
                      >
                        <i :class="item.estado_stock == true ? 'bx bx-trash-alt' : 'bx bx-list-check'"></i>
                      </b-button>
                      <b-button variant="outline-secondary" @click="modelos_s(item.id)">
                        <i :class="'bx bxs-show'" />
                      </b-button>
                    </b-button-group>
                  </div>
                </template>
              </ResponsiveCards>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
